export default __webpack_public_path__ + "static/proj1-a99d69d6960614f493c55d4ebccdf11d.jpg";